import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthguardService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) {}

  verifyJwt(): Observable<any> {
    const url = this.urlPrefix + 'user/authenticate';
    return this.http
              .get(url, { observe: 'response'})
              .map(
                res => {
                  if (res.status === 200) {
                    return true;
                  } else {
                    return Observable.throw(null);
                  }
              })
              .catch(
                err => {
                  return Observable.throw(err);
              });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/authguard.service.ts